<template>
  <div>
    <v-row>
      <v-col>
        <v-card outlined tile color="transparent">
          <v-card-text>
            <v-row align="center">
              <v-col>
                <v-text-field
                  label="Search"
                  background-color="white"
                  outlined
                  dense
                  :hide-details="true"
                  v-model="filters.search"
                />
              </v-col>

              <v-col>
                <v-select
                  label="Assigned"
                  background-color="white"
                  outlined
                  dense
                  :hide-details="true"
                  :items="assignedOptions"
                  item-value="id"
                  item-text="name"
                  clearable
                  v-model="filters.assigned"
                />
              </v-col>

              <v-col>
                <v-select
                  label="Project"
                  background-color="white"
                  outlined
                  dense
                  :hide-details="true"
                  :items="projectOptions"
                  item-value="id"
                  item-text="name"
                  clearable
                  v-model="filters.project"
                />
              </v-col>

              <v-col>
                <v-checkbox
                  label="Show completed tasks"
                  :hide-details="true"
                  v-model="filters.completed"
                  class="pt-0 mt-0"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="auto" class="pr-2 py-0">
        <v-checkbox style="opacity: 0; height:0;" />
      </v-col>

      <v-col class="pl-0 py-0">
        <v-card color="transparent" tile flat>
          <v-card-text class="pa-0">
            <v-row>
              <v-col cols="3" align="left" class="subtitle-2">Task</v-col>
              <v-col cols="2" align="center" class="subtitle-2">Project</v-col>
              <v-col cols="2" align="center" class="subtitle-2"
                >Task list</v-col
              >
              <v-col cols="2" align="center" class="subtitle-2">Assigned</v-col>
              <v-col cols="2" align="center" class="subtitle-2"
                >Last update</v-col
              >
              <v-col cols="1" align="center" class="subtitle-2"></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="filteredTasks.length">
      <v-col cols="12" v-for="task in filteredTasks" :key="task.id">
        <tasks-table-item :task="task"></tasks-table-item>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12">
        <v-card outlined tile>
          <v-card-title class="subtitle-1">No tasks found.</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TasksTableItem from '@/components/tasks/common/TasksTableItem'
export default {
  name: 'TasksTable',
  props: {
    tasks: {
      type: Array,
      required: true
    }
  },
  components: {
    TasksTableItem
  },
  data() {
    return {
      filters: {
        search: '',
        assigned: null,
        project: null,
        completed: false
      }
    }
  },
  computed: {
    filteredTasks() {
      let filtered = this.tasks || []

      if (this.filters.search !== '') {
        let regex = new RegExp(this.filters.search, 'i')

        filtered = filtered.filter(({ title }) => title.match(regex))
      }

      if (this.filters.assigned !== null) {
        filtered = filtered.filter(
          ({ assigned_to }) =>
            (!assigned_to && this.filters.assigned === 0) ||
            (assigned_to && assigned_to.id == this.filters.assigned)
        )
      }

      if (this.filters.project) {
        filtered = filtered.filter(
          ({ task_list }) => task_list.project.id == this.filters.project
        )
      }

      if (!this.filters.completed) {
        filtered = filtered.filter(({ completed }) => !completed)
      }

      return filtered
    },
    assignedOptions() {
      const options = this.tasks
        .filter((task, index, self) => {
          return (
            task.assigned_to &&
            self.findIndex(t => t.assigned_to.id === task.assigned_to.id) ===
              index
          )
        })
        .map(task => ({ id: task.assigned_to.id, name: task.assigned_to.name }))
        .sort((a, b) => (a.id > b.id ? 1 : -1))

      options.unshift({ id: 0, name: 'Unassigned' })

      return options
    },
    projectOptions() {
      return this.tasks
        .filter((task, index, self) => {
          return (
            self.findIndex(
              t => t.task_list.project.id === task.task_list.project.id
            ) === index
          )
        })
        .map(task => ({
          id: task.task_list.project.id,
          name: task.task_list.project.name
        }))
        .sort((a, b) => (a.id > b.id ? 1 : -1))
    }
  },
  methods: {}
}
</script>
